import React from "react";
import InnerAppVersionList from "./InnerAppVersionList";
import IsvVersionList from "./IsvVersionList";
import { APP_TYPE } from '@src/utils/common'

export default (props)=>{
  if(props?.type === APP_TYPE.innerapp){
    return <InnerAppVersionList {...props} />
  }else if(props?.type === APP_TYPE.isv){
    return <IsvVersionList {...props} />
  }else{
    return null
  }
}
